import { useMemo } from 'react';
import { chartColors } from '../constants/colors';
import { getRandomColors } from '../utils/colors';
export var useChartColors = function (count) {
    return useMemo(function () { return getRandomColors(chartColors, count); }, [count]);
};
